import React from 'react';
import styled from 'styled-components';

import showroomBar from '../../images/icon/showroomBar.png'

import showroomConfig from '../../data/showroom.js'

import { colorPalette } from '../../Config/colorConfig.js'

const FlexReverseWrapper = styled.div`
    position:relative;
    width:100%; 
    display:flex;
    flex-direction:column;
    & div:nth-child(odd){
        flex-direction: row-reverse;
    }

`

const IntroAndImgWrapper = styled.div`
    position:relative;
    width:100%; 
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
`

const Img = styled.div`
    position:relative;
    width:40%;
    max-width:400px;
    height:250px;
    margin:5px;
    background-repeat: no-repeat;
    background-size: contain;
`
const ShowroomBar = styled.img`
    position:absolute;
    width:60vw;
    max-width:1000px;
    min-width:200px;
    height:auto;
    bottom:0px;
`

const IntroductionWrapper = styled.div`
    position:relative;
    width:40%;
    max-width:360px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    margin:5px;
`

const SubTitle = styled.div`
    display:flex;    
    color: ${colorPalette.myBlue};
    font-size:1.2rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    @media (max-width: 1000px) {
        font-size:1rem;
    }
`

const Introduction = styled.ul`
    color: #000;
    list-style:none;
    font-size:1rem;
    padding:0px;
    &>li{
        line-height:1.5rem;
    }
`

const ShowroomCard=(props)=>{

    const{  cardContent,
            langCh
        }=props

return(
    <FlexReverseWrapper>
    {showroomConfig[cardContent][langCh?'ch':'en'].items.map((item,i)=>
        <IntroAndImgWrapper key={i}>
            <Img style={{backgroundImage: `url(${item.img})`}}>
                <ShowroomBar 
                    style={{right:(i%2) === 0 ? null : 0,
                            left:(i%2) === 0 ? 0 : null,
                            transform: (i%2) === 0 ? 'scale(-1,-1)' : 'scale(1,1)'
                        }}
                    src={showroomBar}
                />
            </Img>
            <IntroductionWrapper>
                <SubTitle>{item.subtitle}</SubTitle>
                <Introduction>
                    {item.introduction.map((data,i)=><li key={i}>{data}</li>)}
                </Introduction>
            </IntroductionWrapper>
        </IntroAndImgWrapper>
    )}
    </FlexReverseWrapper>
    )
}

export default ShowroomCard;